import { render } from "./RejectedSvg.vue?vue&type=template&id=18ddca76"
const script = {}

import exportComponent from "/home/lexmodo/Vue/FraudLabs/fraudlabs_vue/fraudlabs_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__